import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import FormatQuoteIcon from "@material-ui/icons/FormatQuote";

const useStyles = makeStyles((theme) => ({
  root: { padding: theme.spacing(2, 0, 4), textAlign: "center" },
  label: {
    color: "#58EFFE",
    fontSize: "0.76rem",
    fontWeight: 700,
    letterSpacing: "0.15em",
    textTransform: "uppercase",
    marginBottom: theme.spacing(1.2),
  },
  title: {
    color: "#ffffff",
    fontSize: "clamp(1.6rem, 3.5vw, 2.4rem)",
    fontWeight: 800,
    letterSpacing: "-0.02em",
    margin: 0,
    marginBottom: theme.spacing(5),
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: theme.spacing(2),
    textAlign: "left",
    [theme.breakpoints.down("sm")]: { gridTemplateColumns: "1fr" },
  },
  card: {
    padding: theme.spacing(3),
    borderRadius: 20,
    border: "1px solid rgba(255, 255, 255, 0.06)",
    background: "rgba(255, 255, 255, 0.02)",
    backdropFilter: "blur(8px)",
    transition: "all 0.35s ease",
    "&:hover": {
      borderColor: "rgba(88, 239, 254, 0.15)",
      transform: "translateY(-4px)",
      boxShadow: "0 16px 40px rgba(0, 0, 0, 0.3)",
    },
  },
  quoteIcon: {
    fontSize: 28,
    color: "rgba(88, 239, 254, 0.2)",
    marginBottom: theme.spacing(1.5),
  },
  quote: {
    color: "rgba(255, 255, 255, 0.65)",
    fontSize: "0.92rem",
    lineHeight: 1.7,
    fontStyle: "italic",
    marginBottom: theme.spacing(2.5),
  },
  author: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.2),
  },
  avatar: {
    width: 42,
    height: 42,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 800,
    fontSize: "0.85rem",
    color: "#000000",
    background: "linear-gradient(135deg, #58EFFE, #39F3CC)",
    boxShadow: "0 4px 16px rgba(88, 239, 254, 0.2)",
  },
  authorName: {
    color: "#ffffff",
    fontSize: "0.88rem",
    fontWeight: 700,
    lineHeight: 1.2,
  },
  authorRole: {
    color: "rgba(255, 255, 255, 0.35)",
    fontSize: "0.74rem",
    marginTop: 2,
  },
}));

const testimonials = [
  {
    quote: "Klorum centraliza tu operación comercial: WhatsApp, llamadas, IA y seguimiento en una sola plataforma. Diseñado para equipos que escalan rápido.",
    name: "Plataforma comercial",
    role: "Diseñada para crecer con tu negocio",
    initials: "K",
  },
  {
    quote: "Automatización inteligente con IA, atención omnicanal y métricas en tiempo real. Tu equipo gana foco, tus clientes ganan respuestas inmediatas.",
    name: "IA + Omnicanalidad",
    role: "Tecnología que impulsa ventas",
    initials: "AI",
  },
  {
    quote: "Configura flujos visuales, conecta canales en minutos y empieza a operar. Sin complicaciones técnicas, con soporte 24/7.",
    name: "Listo en minutos",
    role: "Sin código, sin instalaciones",
    initials: "F",
  },
];

export default function TestimonialsSection({ resolveText }) {
  const classes = useStyles();

  return (
    <section className={`${classes.root} gsap-fade-in`}>
      <p className={classes.label}>
        {resolveText("landing.testimonials.label") !== "landing.testimonials.label"
          ? resolveText("landing.testimonials.label")
          : "Lo que dicen nuestros clientes"}
      </p>
      <h2 className={classes.title}>
        {resolveText("landing.testimonials.title") !== "landing.testimonials.title"
          ? resolveText("landing.testimonials.title")
          : "Resultados que hablan por sí solos"}
      </h2>

      <div className={classes.grid}>
        {testimonials.map((t) => (
          <div key={t.name} className={classes.card}>
            <FormatQuoteIcon className={classes.quoteIcon} />
            <p className={classes.quote}>{t.quote}</p>
            <div className={classes.author}>
              <div className={classes.avatar}>{t.initials}</div>
              <div>
                <div className={classes.authorName}>{t.name}</div>
                <div className={classes.authorRole}>{t.role}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
